import { FlagDataType } from './flagDateType-enum';
export var WordDataType = FlagDataType.Int32 | FlagDataType.Float;
export var WordExceptBHDataType = FlagDataType.Int32 | FlagDataType.Float;
export var BitwiseDataType = FlagDataType.Int32;
export var AlarmEventDataType = FlagDataType.Int32 | FlagDataType.Float | FlagDataType.Bool;
